import {GiftCardShopStackNavigator} from '../../giftCardShop/GiftCardShopStackNavigator';
import {AppRoute} from '../../models/AppRoute';
import {STORE_NAME} from '../../screens/constants';
import {header} from '../components/Header';

import {commonTabRouteProps} from './commonRouteProps';
import {RouteSpec, RouteWithoutTargetStoreType, TargetStoreType} from './types';

const tabRoutes: RouteWithoutTargetStoreType[] = [
  {
    name: AppRoute.GIFT_CARDS_MAIN,
    component: GiftCardShopStackNavigator,
    header: header({
      back: false,
      shop: false,
      filter: false,
      burger: true,
      search: false,
      source: STORE_NAME,
    }),
    ...commonTabRouteProps,
  },
];

const giftCardsStoreAppRoutes: RouteSpec[] = [
  ...tabRoutes,
  // ...noTabOrDrawerRoutes,
].map(routeWithNoTargetStoreType => {
  const route: RouteSpec = {
    ...routeWithNoTargetStoreType,
    targetStoreType: TargetStoreType.GiftCardStore,
  };
  return route;
});

export default giftCardsStoreAppRoutes;
